import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { fetchTranslates } from '../Services/Requests.js';
import { useRecoilValue } from 'recoil';
import { Languege } from '../Atom/index.js';

interface NewsItem {
    title: string;
    time: string;
    iconSrc: string;
}

export const NewsAside = ({ data }: { data: any }) => {

    const language = useRecoilValue(Languege);
      const {
    data: Translates,
    isLoading: loadingTranslates,
    error: errorTranslates,
  } = useQuery({
    queryKey: ["Translates", language],
    queryFn: fetchTranslates,
  });
    const navigate = useNavigate();

    return (
        <section className="asideNews flex flex-col px-4 py-3.5 bg-white rounded-lg shadow-[0px_0px_11px_rgba(101,101,101,0.12)] max-md:mt-6 h-fit">
            <div className="flex gap-5 justify-between items-center py-5 w-full text-black border-b border-gray-200">
                <h2 className="self-stretch my-auto text-xl font-medium">
                    {Translates?.data.data.news_feed}
                </h2>
                {/* <button
                    className="flex gap-2.5 justify-center items-center self-stretch my-auto text-sm rounded"
                    aria-label="View all news"
                > 
                    <span className="self-stretch my-auto">bütün xəbərlər</span>
                    <img
                        loading="lazy"
                        src="https://cdn.builder.io/api/v1/image/assets/c6f3c7bb740649e5a32c147b3037a1c2/331a3753eb8e092f076a0864e036d658215dd5ebe69a586c0297acac9e7616a2?apiKey=c6f3c7bb740649e5a32c147b3037a1c2&"
                        alt=""
                        className="object-contain shrink-0 self-stretch my-auto w-4 aspect-square"
                    />
                </button> */}
            </div>
            <div>
                {data.map((item: any, index: number) => (
                    <div
                        key={index}
                        className="flex flex-col py-3 w-full border-b border-gray-200 cursor-pointer"
                        onClick={() => navigate(`/news/${item.id}`)}
                    >
                        <h3 className="text-base text-black asideItemTitle">{item.title}</h3>
                        <div className="flex gap-2.5 items-center self-start mt-2 text-xs whitespace-nowrap text-zinc-300">
                            <img
                                loading="lazy"
                                src={
                                    'https://cdn.builder.io/api/v1/image/assets/c6f3c7bb740649e5a32c147b3037a1c2/331a3753eb8e092f076a0864e036d658215dd5ebe69a586c0297acac9e7616a2?apiKey=c6f3c7bb740649e5a32c147b3037a1c2&'
                                }
                                alt=""
                                className="object-contain shrink-0 self-stretch my-auto w-3.5 aspect-square"
                            />
                            <time className="self-stretch my-auto">
                                {item.date}
                            </time>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};
